// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2lDjt","content":"Consent_content__1MJaM","footer":"Consent_footer__3blR0"};